import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Crosshair } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  const navigate = useNavigate();
  return <section id="inicio" className="relative min-h-[100svh] flex items-center justify-center pb-12 overflow-hidden bg-neutral-950" style={{
    paddingTop: 'calc(var(--header-height) + 48px)'
  }} data-id="element-52">
      {/* Tactical Crosshair Background Motif */}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center opacity-20" data-id="element-53">
        <div className="w-[1px] h-screen bg-red-500 absolute left-1/2 -translate-x-1/2" data-id="element-54" />
        <div className="h-[1px] w-screen bg-red-500 absolute top-1/2 -translate-y-1/2" data-id="element-55" />
        <div className="w-[40vw] h-[40vw] max-w-[600px] max-h-[600px] border border-red-500 rounded-full absolute" data-id="element-56" />
        <div className="w-[38vw] h-[38vw] max-w-[570px] max-h-[570px] border border-red-500/30 rounded-full absolute border-dashed" data-id="element-57" />
      </div>

      {/* Gradient overlay to fade out the crosshair at edges */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,#0a0a0a_70%)] pointer-events-none" data-id="element-58" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 w-full flex flex-col items-center text-center" data-id="element-59">
        <FadeIn delay={0.1} data-id="element-60">
          <div className="flex items-center gap-2 mb-6" data-id="element-61">
            <Crosshair size={14} className="text-red-500" data-id="element-62" />
            <span className="text-xs font-bold tracking-[0.2em] text-red-500 uppercase" data-id="element-63">
              Formación para Traders
            </span>
            <Crosshair size={14} className="text-red-500" data-id="element-64" />
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-65">
          <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-black tracking-tighter text-white mb-6 leading-[1.05]" data-id="element-66">
            PROTOCOLO
            <br data-id="element-67" />
            <span className="text-transparent bg-clip-text bg-gradient-to-b from-white to-neutral-500 pb-1 inline-block" data-id="element-68">
              SNIPER
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-69">
          <p className="text-lg md:text-xl text-neutral-300 max-w-2xl mx-auto mb-10 text-balance" data-id="element-70">
            Formación real para traders que quieren dejar de improvisar y operar
            con criterio.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-71">
          <ul className="flex flex-col gap-4 text-left max-w-xl mx-auto mb-12 bg-neutral-900/50 backdrop-blur-sm border border-neutral-800 p-6 md:p-8 rounded-sm" data-id="element-72">
            {['Lectura clara del precio (sin humo, sin señales mágicas).', 'Método entrenable: ver → confirmar → ejecutar → salir.', 'Mentoría privada de 3 meses: clases, correcciones y comunidad sin dependencia.'].map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-73">
                <div className="w-1.5 h-1.5 bg-red-600 rounded-sm mt-2 shrink-0" data-id="element-74" />
                <span className="text-neutral-300 text-sm md:text-base" data-id="element-75">
                  {bullet}
                </span>
              </li>)}
          </ul>
        </FadeIn>

        <FadeIn delay={0.5} className="flex flex-col items-center gap-6 w-full max-w-md mx-auto" data-id="element-76">
          <button onClick={() => navigate('/mentoria')} className="bg-red-600 hover:bg-red-500 text-white font-semibold py-4 px-10 rounded-sm transition-all text-center border border-red-500 hover:border-red-400 shadow-[0_0_20px_rgba(220,38,38,0.2)] uppercase tracking-wider text-sm cursor-pointer" data-id="element-77">
            Ver Mentoría
          </button>
        </FadeIn>
      </div>
    </section>;
}